module.exports = __webpack_public_path__ + "img/img15.ff8c0265.png";